<template>
 	<b-container v-if="$can('view-payments') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>payments</h3>
                    </b-col>
                    <b-col class="buttons-create text-right">
                        <b-button variant="outline-primary" size="sm" @click="openModal('charge-credit-card')" v-if="$can('view-payment-charge-credit-card') || $can('view-all')">New Credit Card Payment</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('receive-payment')">New Other Payment</b-button>
                        <b-button v-if="$can('execute-export') || $can('view-all')" variant="outline-primary" size="sm" @click="openModal('export-columns')">Export</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('adjust-columns')"><i class="fas fa-columns"></i></b-button>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>

        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="4">
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="tables.payments.filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                              debounce="500"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!tables.payments.filter" @click="tables.payments.filter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                    </b-col>

                    <!-- <b-col class="text-center" cols="3">
                        <b-button v-if="tables.payments.hasQueryClicks" variant="danger" size="sm" @click="clearQueryClicks">Clear Filters</b-button>
                    </b-col> -->

                    <b-col cols="3">
                        <b-form-row>
                            <b-col cols="6">
                                <b-form-datepicker v-model="tables.payments.rowFilters.dateFrom" id="filter-dateFrom" size="sm"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en" today-button
                                    close-button reset-button></b-form-datepicker>
                            </b-col>
                            <b-col cols="6">
                                <b-form-datepicker v-model="tables.payments.rowFilters.dateTo" id="filter-dateTo" size="sm"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="en" today-button
                                    close-button reset-button></b-form-datepicker>
                            </b-col>
                        </b-form-row>
                    </b-col>

                    <b-col cols="2">
                        <treeselect name="depositAccountSelect" class="deposit-account-select" clearable open-on-click clear-on-select
                            close-on-select disableBranchNodes placeholder="Filter by Account" :options="tables.payments.depositAccounts"
                            @input="filterSelect($event, 'depositAccount')" ref="selectDepositAccount" />
                    </b-col>

                    <b-col cols="2">
                        <treeselect name="paymentMethodSelect" class="payment-methods-select" clearable searchable open-on-click clear-on-select
                            close-on-select disableBranchNodes placeholder="Filter by Payment Method" :options="tables.payments.paymentMethods"
                            @input="filterSelect($event, 'paymentMethod')" ref="selectPaymentMethods" />
                    </b-col>

                    <b-col cols="1">
                        <b-form-group>
                          <b-form-select
                            v-model="tables.payments.perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="tables.payments.pageOptions"
                          ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-payments-table">
                    <b-container fluid>
                        <b-table v-if="tables.payments.ready" ref="paymentsTable" :key="tables.payments.key" class="payments-table" responsive bordered striped
                            hover no-border-collapse sticky-header="calc(100vh - 250px)" head-variant="light" :items="paymentsProvider"
                            :fields="visibleFields" :sort-by.sync="tables.payments.sortBy" :sort-desc.sync="tables.payments.sortDesc"
                            :per-page="tables.payments.perPage" :current-page.sync="tables.payments.currentPage" :filter="tables.payments.filter"
                            :busy.sync="tables.payments.isBusy">

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(id)="row">
                                <span><b-link @click="openModal('edit-payment', row.item)">{{ row.item.id }}</b-link></span>
                            </template>

                            <template v-slot:cell(amount_total)="row">
                                <span>$ {{ numberWithCommas(row.item.amount_total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(amount_available)="row">
                                <span>$ {{ numberWithCommas(row.item.amount_available) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(customer)="row">
                                <span>{{ row.item.customer.name }}</span>
                            </template>

                            <template v-slot:cell(deposit_acct)="row">
                                <span>{{ row.item.deposit_acct ? row.item.deposit_acct.name : '' }}</span>
                            </template>

                            <template v-slot:cell(payment_method)="row">
                                <span>{{ row.item.payment_method ? row.item.payment_method.name : '' }}</span>
                            </template>

                            <template v-slot:cell(payments_applieds)="row">
                                <div v-if="row.item.payments_applieds">
                                    <div v-for="applied in row.item.payments_applieds" :key="applied.id">
                                        <b-link @click="saveState('paymentsTableRow' + row.item.id)"
                                            :to="{ name: 'SalesOrderDetail', params: { soNum: applied.sales_order.sales_order_number } }">
                                            {{ applied.sales_order.sales_order_number }}
                                        </b-link> - ${{ applied.applied_amount }}<br />
                                    </div>
                                </div>
                            </template>

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <!-- Temporarily hidden void/refund functionality
                                        <b-col v-if="row.item.payment_method && row.item.payment_method.name && row.item.payment_method.name.toLowerCase().includes('credit')">
                                            <b-button 
                                                size="sm" 
                                                variant="outline-warning" 
                                                @click="openVoidRefundModal(row.item)"
                                                :disabled="!row.item.reference"
                                            >
                                                <i class="fas fa-undo"></i> Void/Refund
                                            </b-button>
                                        </b-col>
                                        -->
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination
                          v-model="tables.payments.currentPage"
                          :total-rows="tables.payments.totalRows"
                          :per-page="tables.payments.perPage"
                          align="fill"
                          size="sm"
                          class="my-0"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <modal-adjust-columns
            v-if="modals['adjust-columns'].active"
            :fields="modals['adjust-columns'].fields"
            @saveColSaves="saveColSaves"
        />

        <modal-export-columns
            v-if="modals['export-columns'].active"
            :fields="modals['export-columns'].fields"
            :ignores="modals['export-columns'].ignores"
            @exportExcel="exportExcel"
        />

        <modal-edit-payment v-if="modals['edit-payment'].active" :paymentInfo="modals['edit-payment'].paymentInfo"
            :customerId="modals['edit-payment'].paymentInfo.customerId" @getPayments="refreshPaymentsTable" />

        <modal-receive-payment v-if="modals['receive-payment'].active" @getPayments="refreshPaymentsTable" />
        
        <modal-charge-credit-card v-if="modals['charge-credit-card'].active" :showSalesOrdersSection="true" @paymentProcessed="onPaymentProcessed" @showPaymentResult="onShowPaymentResult" />
        
        <!-- Void/Refund Modal -->
        <b-modal 
            id="void-refund-modal" 
            title="Void/Refund Credit Card Payment" 
            size="lg"
            centered
        >
            <b-container fluid>
                <b-row class="mb-3">
                    <b-col>
                        <h6>Payment Details:</h6>
                        <p><strong>Amount:</strong> ${{ numberWithCommas(voidRefundData.amount) }}</p>
                        <p><strong>Customer:</strong> {{ voidRefundData.customerName }}</p>
                        <p><strong>Transaction ID:</strong> {{ voidRefundData.reference }}</p>
                        <p><strong>Date:</strong> {{ voidRefundData.date }}</p>
                    </b-col>
                </b-row>
                
                <b-row class="mb-3">
                    <b-col>
                        <b-form-group label="Reason:" label-for="void-refund-reason">
                            <b-form-textarea 
                                id="void-refund-reason" 
                                v-model="voidRefundData.reason" 
                                placeholder="Enter reason for void/refund..."
                                rows="3"
                                required
                            ></b-form-textarea>
                            <small class="text-muted">
                                Kaja will automatically determine whether to void or refund based on the transaction state.
                            </small>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
            
            <template v-slot:modal-footer>
                <div class="w-100 text-center">
                    <b-button 
                        variant="secondary" 
                        @click="$bvModal.hide('void-refund-modal')"
                        class="mr-2"
                    >
                        Cancel
                    </b-button>
                    <b-button 
                        variant="warning" 
                        @click="processVoidRefund"
                        :disabled="!voidRefundData.reason"
                    >
                        <b-spinner small v-if="isProcessingVoidRefund"></b-spinner>
                        {{ isProcessingVoidRefund ? 'Processing...' : 'Process Reversal' }}
                    </b-button>
                </div>
            </template>
        </b-modal>

        <!-- Payment Result Modal -->
        <b-modal 
            id="payment-result-modal" 
            :title="paymentResult.title" 
            :header-bg-variant="paymentResult.variant"
            :header-text-variant="paymentResult.variant === 'danger' ? 'white' : 'dark'"
            :body-bg-variant="paymentResult.variant === 'danger' ? 'light' : 'white'"
            :body-text-variant="paymentResult.variant === 'danger' ? 'dark' : 'dark'"
            hide-footer
            centered
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="text-center">
                <div class="mb-3">
                    <i :class="paymentResult.icon" style="font-size: 3rem;"></i>
                </div>
                <h5 class="mb-3">{{ paymentResult.message }}</h5>
                <div v-if="paymentResult.details" class="mb-3">
                    <small class="text-muted">{{ paymentResult.details }}</small>
                </div>
            </div>
            
            <template v-slot:modal-footer>
                <div class="w-100 text-center">
                    <b-button 
                        :variant="paymentResult.variant" 
                        @click="closePaymentResult"
                        size="lg"
                    >
                        {{ paymentResult.buttonText }}
                    </b-button>
                </div>
            </template>
        </b-modal>
    </b-container>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ModalAdjustColumns from '../../common/modals/AdjustColumns'
    import ModalExportColumns from '../../common/modals/ExportColumns'
    import ModalEditPayment from '../../lists/customers/modals/EditPayment'
    import ModalReceivePayment from '../../lists/customers/modals/ReceivePayment'
    import ModalChargeCreditCard from '../../common/modals/ChargeCreditCard'
    import { mapMutations } from 'vuex'
    import tableColumnPreferences from '../../../../mixins/tableColumnPreferences'
    import urlQueryFilters from '../../../../mixins/urlQueryFilters'
    import { fetchActivePaymentMethods, paymentMethodsToFilterOptions } from '../../../../utils/receivePaymentMethods'
 	export default {
    	name: 'payments',

        mixins: [tableColumnPreferences, urlQueryFilters],

        metaInfo() {
            return {
                title: 'Payments',
            }
        },

    	components: {
            Treeselect,
            'modal-adjust-columns': ModalAdjustColumns,
            'modal-export-columns': ModalExportColumns,
            'modal-edit-payment': ModalEditPayment,
            'modal-receive-payment': ModalReceivePayment,
            'modal-charge-credit-card': ModalChargeCreditCard
    	},
        data() {
            return {
                modals: {
                    'adjust-columns': {
                        active: 0,
                        fields: []
                    },

                    'export-columns': {
                        active: 0,
                        fields: [],
                        ignores: ['actions']
                    },

                    'edit-payment': {
                        active: 0,
                        paymentInfo: []
                    },

                    'receive-payment': {
                        active: 0
                    },
                    'charge-credit-card': {
                        active: 0
                    },
                },
                tables: {
                    payments: {
                        rowFilters: {

                        },
                        filteredItems: [],
                        isBusy: false,
                        totalRows: 0,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500],
                        sortBy: 'date',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        userFields: [],
                        fields: [
                            {
                                key: 'id',
                                label: 'ID',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'customer',
                                label: 'Customer',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'date',
                                label: 'Date',
                                thClass: 'payments-table-style-th-datetime',
                                tdClass: 'payments-table-style-td-datetime',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'amount_total',
                                label: 'Amount Total',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'amount_available',
                                label: 'Amount Available',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'payment_method',
                                label: 'Payment Method',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'deposit_acct',
                                label: 'Deposit Account',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'notes',
                                label: 'Notes',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'reference',
                                label: 'Reference',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'payments_applieds',
                                label: 'Applied To',
                                sortable: false
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'payments-table-style-actions',
                                visible: 1
                            }
                        ],

                        depositAccounts: [],
                        paymentMethods: [],

                        items: [],
                        ready: 0
                    },
                },

                filters: {
                    selected: {
                        depositAccount: '',
                        paymentMethod: ''
                    }
                },

                exports: {
                    cols: []
                },
                paymentResult: {
                    title: '',
                    message: '',
                    details: '',
                    variant: '',
                    icon: '',
                    buttonText: '',
                    show: false
                },
                voidRefundData: {
                    id: null,
                    amount: 0,
                    customerName: '',
                    reference: '',
                    date: '',
                    reason: ''
                },
                isProcessingVoidRefund: false,
                rowFiltersDebounce: null
            }
        },
        watch: {
            'tables.payments.filter'() {
                this.tables.payments.currentPage = 1
                this.syncUrlQueryFilters()
            },
            'tables.payments.currentPage'() {
                this.syncUrlQueryFilters()
            },
            'tables.payments.perPage'() {
                this.syncUrlQueryFilters()
            },
            'tables.payments.sortBy'() {
                this.syncUrlQueryFilters()
            },
            'tables.payments.sortDesc'() {
                this.syncUrlQueryFilters()
            },
            'tables.payments.rowFilters': {
                handler() {
                    if (!this.tables.payments.ready) {
                        return
                    }

                    if (this.rowFiltersDebounce) {
                        clearTimeout(this.rowFiltersDebounce)
                    }

                    this.rowFiltersDebounce = setTimeout(() => {
                        this.tables.payments.currentPage = 1
                        this.syncUrlQueryFilters()
                        this.refreshPaymentsTable()
                    }, 500)
                },
                deep: true
            }
        },
        methods: {
            getPaymentsExportParams() {
                return {
                    filters: this.filters.selected,
                    search: this.tables.payments.filter,
                    sortBy: this.tables.payments.sortBy,
                    sortDesc: this.tables.payments.sortDesc,
                    columnFilters: this.tables.payments.rowFilters
                }
            },

            filterSelect(name, area) {
                this.filters.selected[area] = name
                this.tables.payments.currentPage = 1
                this.syncUrlQueryFilters()
                this.refreshPaymentsTable()
            },

            exportExcel(cols, keys) {
                let url = 'api/accounting/payments/exportpayments'
                axios.post(url, {
                    ...this.getPaymentsExportParams(),
                    cols: cols,
                    keys: keys
                },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
            },

            forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'payments_Export_File_' + +new Date() + '.xlsx') //or any other extension
                document.body.appendChild(link)
                link.click()

                this.showAlertBox('success', 'File Generated', 'Sales Orders export file generated successfully!')
            },

            saveState(name) {
                let page = this.tables.payments.currentPage
                let filter = this.tables.payments.filter
                let perPage = this.tables.payments.perPage
                this.setRememberCustomer({name: name, page: page, filter: filter, perPage: perPage })
            },

            openModal(modalName, row, extra) {
                let prefix = 'modal-lists-payments-'
                switch (modalName) {
                    case 'adjust-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = this.cloneFieldsForAdjust(this.tables.payments.userFields, this.tables.payments.fields)

                        break
                    case 'export-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = JSON.parse(JSON.stringify(this.tables.payments.fields.filter(e => !this.modals[modalName].ignores.includes(e.key))))

                        break
                    case 'edit-payment':
                        this.modals[modalName].active = 1
                        this.modals[modalName].paymentInfo.id = row.id
                        this.modals[modalName].paymentInfo.customerId = row.customers_id
                        this.modals[modalName].paymentInfo.date = row.date
                        this.modals[modalName].paymentInfo.amount = row.amount_total
                        this.modals[modalName].paymentInfo.payment_types_id = row.payment_types_id
                        this.modals[modalName].paymentInfo.deposit_accounts_id = row.deposit_accounts_id
                        this.modals[modalName].paymentInfo.reference = row.reference
                        this.modals[modalName].paymentInfo.notes = row.notes

                        break
                    case 'receive-payment':
                        this.modals[modalName].active = 1

                        break
                    case 'charge-credit-card':
                        this.modals[modalName].active = 1

                        break
                }

                if (modalName == 'adjust-columns' || modalName == 'export-columns' || modalName == 'charge-credit-card') {
                    prefix = 'modal-common-'
                } else if (modalName == 'edit-payment' || modalName == 'receive-payment') {
                    prefix = 'modal-lists-customers-'
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            toggleBusy() {
                this.tables.payments.isBusy = !this.tables.payments.isBusy
            },

            paymentsProvider(ctx) {
                return this.scheduleProviderFetch('payments', ctx, (latestCtx) => {
                    const normalized = this.normalizeTableProviderContext(latestCtx, this.tables.payments)
                    let payload = {
                        ...this.getPaymentsExportParams(),
                        page: normalized.currentPage,
                        perPage: normalized.perPage,
                        sortBy: normalized.sortBy,
                        sortDesc: normalized.sortDesc,
                        search: normalized.filter
                    }

                    return axios.post('api/accounting/payments/getpayments', payload)
                    .then((res) => {
                        this.tables.payments.items = res.data.payments
                        this.tables.payments.totalRows = res.data.total
                        this.populateDepositAccounts()
                        return res.data.payments || []
                    }, () => {
                        this.has_error = true
                        return []
                    })
                })
            },

            refreshPaymentsTable() {
                if (this.$refs.paymentsTable) {
                    this.$refs.paymentsTable.refresh()
                }
            },

            initPayments() {
                this.tables.payments.filter = this.rememberedPayment.filter || ''
                this.tables.payments.perPage = this.rememberedPayment.perPage || 20

                if (this.rememberedPayment.page) {
                    this.tables.payments.currentPage = this.rememberedPayment.page
                }

                this.applyUrlQueryFilters()
                this.tables.payments.ready = 1

                this.$nextTick(() => {
                    this.enableUrlQueryFilters()
                    this.setLastState()
                })
            },

            urlQueryFilterConfig() {
                return {
                    search: { path: 'tables.payments.filter', query: 'q' },
                    page: { path: 'tables.payments.currentPage', query: 'page', type: 'number' },
                    perPage: { path: 'tables.payments.perPage', query: 'perPage', type: 'number' },
                    sortBy: { path: 'tables.payments.sortBy', query: 'sortBy' },
                    sortDesc: { path: 'tables.payments.sortDesc', query: 'sortDesc', type: 'boolean' },
                    fields: [
                        { path: 'tables.payments.rowFilters.dateFrom', query: 'from' },
                        { path: 'tables.payments.rowFilters.dateTo', query: 'to' },
                        { path: 'filters.selected.depositAccount', query: 'account' },
                        { path: 'filters.selected.paymentMethod', query: 'method' },
                    ],
                }
            },

            onUrlQueryFiltersApplied() {
                this.refreshPaymentsTable()
            },

            setLastState() {
                this.$nextTick(() => {
                    if (this.rememberedPayment.name && this.rememberedPayment.page) {
                        this.tables.payments.currentPage = this.rememberedPayment.page
                        this.$nextTick(() => {
                            this.$refs[this.rememberedPayment.name].$el.scrollIntoView()
                        })
                    }
                })
            },

            // ...mapMutations({
            //     setRemember: 'remembered/SET_PAYMENT'

            // }),

            getColSaves() {
                let url = 'api/remembertable/getcolsaves/payments'
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            const merged = this.mergeColSaves(this.tables.payments.fields, res.data.colSaves.column_array)
                            if (merged) {
                                this.tables.payments.userFields = merged
                            }
                        }

                        this.initPayments()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            saveColSaves(fields) {
                const normalized = this.normalizeColumnOrder(fields)
                this.tables.payments.userFields = normalized
                let url = 'api/remembertable/savecolsaves'
                axios.post(url, {
                    area: 'payments',
                    fields: this.formatColSavesPayload(normalized)
                })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
            },

            forceRerender() {
                this.tables.payments.ready = 0
                let tempFields = this.tables.payments.fields
                this.tables.payments.fields = []
                this.$nextTick(() => {
                    this.tables.payments.fields = tempFields
                    this.tables.payments.ready = 1
                })
            },

            getPaymentMethodsFilter() {
                fetchActivePaymentMethods().then((methods) => {
                    this.tables.payments.paymentMethods = paymentMethodsToFilterOptions(methods)
                })
            },

            populateDepositAccounts() {
                let output = []
                for (let item of this.tables.payments.items) {
                    if (item.deposit_acct) {
                        output.push({ id: item.deposit_acct.id, label: item.deposit_acct.name })
                    }
                }

                let uniqueChars = [...new Map(output.map((m) => [m.label, m])).values()];
                this.tables.payments.depositAccounts = uniqueChars
            },

            onPaymentProcessed(paymentData) {
                // Refresh the payments data to reflect the new payment
                this.refreshPaymentsTable()
            },

            onShowPaymentResult(paymentResult) {
                this.paymentResult = paymentResult;
                this.$bvModal.show('payment-result-modal');
            },

            closePaymentResult() {
                this.$bvModal.hide('payment-result-modal')
            },

            numberWithCommas(x) {
                if (!x) return '0.00';
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },

            openVoidRefundModal(payment) {
                this.voidRefundData.id = payment.id;
                this.voidRefundData.amount = payment.amount_total;
                this.voidRefundData.customerName = payment.customer ? payment.customer.name : '';
                this.voidRefundData.reference = payment.reference;
                this.voidRefundData.date = payment.date;
                this.$bvModal.show('void-refund-modal');
            },

            async processVoidRefund() {
                this.isProcessingVoidRefund = true;
                try {
                    const url = 'api/accounting/payments/voidrefund';
                    const payload = {
                        id: this.voidRefundData.id,
                        reason: this.voidRefundData.reason
                    };

                    const response = await axios.post(url, payload);
                    if (response.data.status === 'success') {
                        this.onShowPaymentResult({
                            title: 'Payment Processed',
                            message: `Payment ${response.data.data.actual_kaja_action.toLowerCase()} successfully!`,
                            details: `Kaja automatically chose to ${response.data.data.actual_kaja_action.toLowerCase()} this transaction based on its current state.`,
                            variant: 'success',
                            icon: 'fas fa-check-circle',
                            buttonText: 'OK'
                        });
                        this.refreshPaymentsTable();
                    } else {
                        this.onShowPaymentResult({
                            title: 'Error Processing Payment',
                            message: response.data.message || 'Failed to process payment.',
                            variant: 'danger',
                            icon: 'fas fa-times-circle',
                            buttonText: 'OK'
                        });
                    }
                } catch (error) {
                    this.onShowPaymentResult({
                        title: 'Error Processing Payment',
                        message: error.response?.data?.message || 'Failed to process payment.',
                        variant: 'danger',
                        icon: 'fas fa-times-circle',
                        buttonText: 'OK'
                    });
                } finally {
                    this.isProcessingVoidRefund = false;
                    this.$bvModal.hide('void-refund-modal');
                }
            }
        },

    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.payments.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotals() {
                let totalRows = this.tables.payments.totalRows
                let currentPage = this.tables.payments.currentPage
                let perPage = this.tables.payments.perPage

                if (!totalRows) {
                    return 'Showing 0 of 0 rows'
                }

                let from = ((currentPage - 1) * perPage) + 1
                let to = Math.min(currentPage * perPage, totalRows)

                return 'Showing ' + from + ' to ' + to + ' of ' + totalRows + ' rows'
            },

            visibleFields() {
                return this.buildVisibleFields(this.tables.payments.fields, this.tables.payments.userFields)
            }
	    },

	    mounted() {
            this.getColSaves()
            this.getPaymentMethodsFilter()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                     case 'modal-common-adjust-columns':
                        this.modals['adjust-columns'].active = 0
                        this.modals['adjust-columns'].fields = []

                        break
                    case 'modal-common-export-columns':
                        this.modals['export-columns'].active = 0
                        this.modals['export-columns'].fields = []

                        break
                    case 'modal-lists-customers-edit-payment':
                        this.modals['edit-payment'].active = 0
                        this.modals['edit-payment'].paymentInfo = []

                        break
                    case 'modal-lists-customers-receive-payment':
                        this.modals['receive-payment'].active = 0

                        break
                    case 'modal-common-charge-credit-card':
                        this.modals['charge-credit-card'].active = 0

                        break
                    case 'void-refund-modal':
                        // Reset void/refund form data
                        this.voidRefundData = {
                            id: null,
                            amount: 0,
                            customerName: '',
                            reference: '',
                            date: '',
                            reason: ''
                        }
                        this.isProcessingVoidRefund = false
                        break
                }
            })

            // pusher
            // Echo.channel('table-payment-updated')
            //     .listen('TablePaymentUpdated', (e) => {
            //         this.getPayments(1)
            // })
	    }
  }
</script>
<style lang="scss">
    .vue-treeselect__control {
        // height: calc(1.5em + 0.5rem + 2px);
        // padding-top: 0.25rem;
        // padding-bottom: 0.25rem;
        // padding-left: 0.5rem;
        font-size: 0.875rem !important;

        .vue-treeselect__placeholder, .vue-treeselect__single-value {
            // line-height: 1.5
        }
    }

    .payments-table {
        height: 75vh;
        font-size: 9pt;

        .payments-table-style-actions {
            min-width: 120px;

            .actions-icons {
                text-align: center;
                white-space: nowrap;
            }
        }

        .payments-table-style-th-datetime {
            min-width: 110px;
        }

        .payments-table-style-td-datetime {
            text-align: center;
        }
    }
</style>
